<div class="connection-request-container">
  <div class="connection-request">
    <div class="logo">
      <img [src]="vendorLogo" [alt]="vendorName" width="42px" loading="lazy" />
    </div>
    <div class="body">
      <div class="subject">
        <ng-container *ngIf="pendingInvite">
          <div class="title">
            <span class="company-name" (click)="companyClick($event)">{{
              vendorName
            }}</span>
            has sent you an opportunity.
          </div>
          <div class="subtitle">
            <b>{{ vendorName }}</b> invited you to participate in
            <span class="company-name" (click)="opportunityClick($event)">{{
              opportunityName
            }}</span>
          </div>
        </ng-container>
        <ng-container *ngIf="intentToQuote">
          <div class="title">Congratulations!</div>
          <div class="subtitle">
            You've accepted the invite to quote from <b>{{ vendorName }}</b> for
            project
            <span class="company-name" (click)="opportunityClick($event)">{{
              opportunityName
            }}</span
            >, you can now <b>submit a quote.</b> <br /><br />
            Changed your mind?
          </div>
        </ng-container>
        <ng-container *ngIf="noQuoteStatus">
          <div class="title">Opportunity declined</div>
          <div class="subtitle">
            You've declined the invite to quote from <b>{{ vendorName }}</b> for
            project
            <span class="company-name" (click)="opportunityClick($event)">{{
              opportunityName
            }}</span>
            .If you change your mind, click I intend to quote below.
          </div>
        </ng-container>
      </div>
      <div class="actions">
        <s-button
          type="secondary"
          skin="red"
          size="small"
          [icon]="'pi pi-times-circle'"
          iconPos="left"
          [label]="'No Quote'"
          (click)="declineProject()"
          *ngIf="pendingInvite || intentToQuote"
        ></s-button>
        <s-button
          type="primary"
          skin="green"
          size="small"
          [icon]="'pi pi-check-circle'"
          icon="pi pi-check-circle"
          iconPos="left"
          [label]="'I intend to quote'"
          (click)="acceptProject()"
          *ngIf="pendingInvite || noQuoteStatus"
        ></s-button>
      </div>
    </div>
  </div>
</div>
